import { DataTable } from '../../../../../components/UI/MDC/DataTable/DataTable';
import ComponentForm from './ComponentForm/ComponentForm';
import AppDataManagement from './AppDataManagement/AppDataManagement';
import ComponentDependencyManagement from './ComponentDependencyManagement/ComponentDependencyManagement';
//app : AppManagementModel
//reload :  callback function
//components : AppComponent[]

const ComponentsTable = ({
	app,
	currentUser,
	components,
	reload,
	readOnly,
	requirementNumber,
}) => {
	const headers = [
		{ Value: 'Actions', props: { sort: null, onSortChange: null } },
		{ Value: 'Label', props: { sort: null, onSortChange: null } },
		{ Value: 'Component Type', props: { sort: null, onSortChange: null } },
		{ Value: 'Component ID', props: { sort: null, onSortChange: null } },
		{ Value: 'Extension ID', props: { sort: null, onSortChange: null } },
	];
	
	const rows = components.map((component, index) => {
		return {
			Cells: {
				Actions: {
					Value: (
						<>
							<ComponentForm
								component={component}
								app={app}
								currentUser={currentUser}
								reload={reload}
								readOnly={readOnly}
								requirementNumber={requirementNumber}
							/>
							<AppDataManagement
								component={component}
								app={app}
								currentUser={currentUser}
								reload={reload}
								readOnly={readOnly}
								requirementNumber={requirementNumber}
							/>
							<ComponentDependencyManagement
								component={component}
								app={app}
								currentUser={currentUser}
								reload={reload}
								readOnly={readOnly}
								requirementNumber={requirementNumber}
							/>
						</>
					),
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
				Label: {
					Value: component.label,
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
				'Component ID': {
					Value: component.id,
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
				'Extension ID': {
					Value: component.extension?.fiid,
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
				'Component Type': {
					Value: component.componentType.description,
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
			},
			Key: component.id.toString(),
		};
	});

	return (
		<div>
			<DataTable rows={rows} headers={headers} />
			{/* {new Component Form} */}
			<ComponentForm
				app={app}
				currentUser={currentUser}
				reload={reload}
				readOnly={readOnly}
				requirementNumber={requirementNumber}
			/>
		</div>
	);
};

export default ComponentsTable;
